import React from "react";
import { Step } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  RECOVER_FASE_VALIDATION,
  RECOVER_FASE_CONFIRMATION,
} from "../../../../../app/infrastructure/appConstants";
import PropTypes from "prop-types";

const mapState = (state) => ({
  fase: state.recoverUser.fase,
});
const RecoverFormStep = ({ fase }) => {
  return (
    <Step.Group ordered fluid>
      <Step
        completed={fase > RECOVER_FASE_VALIDATION}
        active={fase === RECOVER_FASE_VALIDATION}
      >
        <Step.Content>
          <Step.Title>Validación</Step.Title>
        </Step.Content>
      </Step>

      <Step
        completed={fase > RECOVER_FASE_CONFIRMATION}
        active={fase === RECOVER_FASE_CONFIRMATION}
      >
        <Step.Content>
          <Step.Title>Recuperación</Step.Title>
        </Step.Content>
      </Step>
    </Step.Group>
  );
};

RecoverFormStep.propTypes = {
  fase: PropTypes.number.isRequired,
};

export default connect(mapState, null)(RecoverFormStep);
